'use strict';


//dependencies included for running in node
if (typeof exports !== 'undefined') {
	if (typeof module !== 'undefined' && module.exports) {
		var Gender = require('../lib/gender');
		var calcToolkit = require('@lifetime-gallagher/calculator-toolkit');
		var dateUtils = calcToolkit.dateUtils;
		var dateConstants = calcToolkit.dateConstants;
	}
}

//annuity table returns raw annuity rates from the data held
// the annuity model (model/annuity.js) is responsible for any transformation on these rates
var AnnuityTable = function(annuities) {
	this.INCREASE_RATE_KEY = 'increase:';
	this.GUARANTEE_KEY = 'guarantee:';

	this.male = annuities.male;
	this.female = annuities.female;
	this.expense = annuities.expense;
};

AnnuityTable.prototype.getRate = function(gender, yearOfBirth, retirementAge, options) {
	var table = this.rates(gender);
	var increaseRate = this.INCREASE_RATE_KEY + options.increaseRate;
	var guaranteePeriod = this.GUARANTEE_KEY + options.guaranteePeriod;

	if(table === null) {
		throw Error('DC-Engine: Invalid gender: ' + gender);
	}	

	if(typeof table[increaseRate] != 'object') {
		throw Error('DC-Engine: Invalid annuity increase rate: ' + increaseRate);
	}

	if(typeof table[increaseRate][guaranteePeriod] != 'object') {
		throw Error('DC-Engine: Invalid annuity guarantee period: ' + guaranteePeriod);
	}

	if(typeof table[increaseRate][guaranteePeriod].rates[yearOfBirth] != 'object') {
		throw Error('DC-Engine: Invalid annuity lookup with year of birth: ' + yearOfBirth);
	}

	if(retirementAge < table[increaseRate][guaranteePeriod].startAge || retirementAge > table[increaseRate][guaranteePeriod].startAge + table[increaseRate][guaranteePeriod].rates[yearOfBirth].length - 1) {
		throw Error('DC-Engine: Invalid annuity lookup with retirement age: ' + retirementAge);
	}

	return table[increaseRate][guaranteePeriod].rates[yearOfBirth][retirementAge - table[increaseRate][guaranteePeriod].startAge];
};

AnnuityTable.prototype.interpolate = function(lowerFactor, upperFactor, lowerAgeBasis, upperAgeBasis, ageBasis) {
	var factorRange = upperFactor - lowerFactor;
    var basisRange = upperAgeBasis - lowerAgeBasis;
    var basisProportion = basisRange ? (ageBasis - lowerAgeBasis) / basisRange : 0;

    return lowerFactor + factorRange * basisProportion;
};

AnnuityTable.prototype.getInterpolatedRate = function(gender, dateOfBirth, retirementDate, options) {
	// use years and complete months
	var decimalRetirementAge = dateUtils.monthsBetween(dateOfBirth, retirementDate) / dateConstants.MONTHS_IN_YEAR;
	var lowerAge = Math.floor(decimalRetirementAge);
	var upperAge = Math.ceil(decimalRetirementAge);
	var lowerRate = this.getRate(gender, dateOfBirth.getFullYear(), lowerAge, options);
	var upperRate = this.getRate(gender, dateOfBirth.getFullYear(), upperAge, options);

	return [
		this.interpolate(lowerRate[0], upperRate[0], lowerAge, upperAge, decimalRetirementAge),
		this.interpolate(lowerRate[1], upperRate[1], lowerAge, upperAge, decimalRetirementAge),
	];
};

AnnuityTable.prototype.getExpense = function() {
	return this.expense;
};

AnnuityTable.prototype.rates = function(gender) {
	if(gender == Gender.MALE) {
		return this.male;
	}

	if(gender == Gender.FEMALE) {
		return this.female;
	}

	return null;
};

//export for node
if (typeof exports !== 'undefined') {
    if (typeof module !== 'undefined' && module.exports) {
        exports = module.exports = AnnuityTable;
    }
    exports.AnnuityTable = AnnuityTable;
}